import React, { useState } from 'react';
import Button from 'components/ui/Button';
import Icon from 'components/AppIcon';

const CallButton = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleCallClick = () => {
    const phoneNumber = 'tel:+919876543210'; // Resort contact number
    window.location.href = phoneNumber;
  };

  return (
    <div className="fixed bottom-6 right-24 z-40">
      <div 
        className="relative"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        {/* Tooltip */}
        {showTooltip && (
          <div className="absolute bottom-full right-0 mb-2 px-3 py-2 bg-card text-card-foreground text-sm rounded-lg shadow-organic-lg whitespace-nowrap">
            Call us directly
            <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-card"></div>
          </div>
        )}

        {/* Call Button */}
        <Button
          variant="default"
          size="icon"
          onClick={handleCallClick}
          className="w-12 h-12 bg-secondary hover:bg-secondary/90 text-secondary-foreground shadow-organic-lg rounded-full"
        >
          <Icon name="Phone" size={20} />
        </Button>
      </div>
    </div>
  );
};

export default CallButton;